"use client"
export default function Loading() {
  // You can add any UI inside Loading, including a Skeleton.
  return (
    <div id="preloader">
      <div className="lds-ripple">
        <div></div> <div></div>
      </div>
    </div>
  )
}